import React, { useEffect, useState, useRef } from 'react';
import { SystemQuote } from './SystemQuote';
import { AlaCarteQuote } from './AlaCarteQuote';
import { CustomerInfo } from './CustomerInfo';
import { Summary } from './Summary';
import { ErrorPopup } from './ErrorPopup';
import { WholesaleInfoPopup } from './WholesaleInfoPopup';
import { pricingData } from '../data/pricingData';
import { callWFAPI } from '../utils/helper';
export function QuoteForm({
  initialEmail = '',
  priceType = 'retail'
}) {
  const [quoteType, setQuoteType] = useState('system');
  const [cart, setCart] = useState({});
  const [loading, setLoading] = useState(false);
  const [hasPendingItems, setHasPendingItems] = useState(false);
  const [showPricing, setShowPricing] = useState(false);
  const [showWholesaleInfo, setShowWholesaleInfo] = useState(false);
  const [errorPopup, setErrorPopup] = useState({
    isOpen: false,
    errorMessage: '',
    debugInfo: null
  });
  const [validationErrors, setValidationErrors] = useState([]);
  const [customer, setCustomer] = useState({
    name: '',
    email: initialEmail,
    phone: '',
    state: '',
    address: '',
    city: '',
    zip: ''
  });
  const quoteOptionsRef = useRef(null);
  // Scroll to Quote Options when component mounts (after email is entered)
  useEffect(() => {
    if (quoteOptionsRef.current) {
      setTimeout(() => {
        quoteOptionsRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 300);
    }
  }, []);
  const handleAddToCart = items => {
    setCart(prevCart => {
      const newCart = {
        ...prevCart
      };
      for (const [key, value] of Object.entries(items)) {
        if (newCart[key]) {
          newCart[key] += value;
        } else {
          newCart[key] = value;
        }
      }
      return newCart;
    });
  };
  const clearCart = () => {
    setCart({});
  };
  const calculateTotal = () => {
    let total = 0;
    for (const [key, quantity] of Object.entries(cart)) {
      const item = pricingData.find(item => item.id === key);
      if (item) {
        total += item[priceType] * quantity;
      }
    }
    return total.toFixed(2);
  };
  const sendQuoteToAPI = async quote => {
    let productsData = [];
    for (let k in quote.cart) if (quote.cart.hasOwnProperty(k)) {
      productsData.push(k + ': ' + quote.cart[k]);
    }
    const zohoParams = {
      Email: quote.customer.email.toLowerCase(),
      Name: quote.customer.name,
      Phone_Number: quote.customer.phone,
      State: quote.customer.state,
      Shipping_Address: quote.customer.address + (quote.customer.city ? '\ncity: ' + quote.customer.city : '') + (quote.customer.zip ? '\nzip: ' + quote.customer.zip : ''),
      Products: productsData.join('\n'),
      total: quote.total,
      price_type: quote.priceType,
      added: quote.date
    };
    const data = {
      appname: 'tkd-score',
      formname: 'Daedo_Gen_3_Purchase_Quote',
      params: JSON.stringify(zohoParams)
    };
    try {
      const res = await callWFAPI(0, 'zohoCreator', data);
      return res['ID'];
    } catch (error) {
      throw {
        error,
        zohoParams
      };
    }
  };
  const saveQuote = async () => {
    const quote = {
      date: new Date().toISOString(),
      cart: cart,
      customer: customer,
      total: calculateTotal(),
      priceType: priceType
    };
    const id = await sendQuoteToAPI(quote);
    quote.id = id;
    const savedQuotes = localStorage.getItem('my_quotes');
    const quotes = savedQuotes ? JSON.parse(savedQuotes) : [];
    quotes.push(quote);
    localStorage.setItem('my_quotes', JSON.stringify(quotes));
  };
  const handleSubmit = async () => {
    const errors = [];
    if (hasPendingItems) {
      errors.push('You have pending items — please press "Add to Quote" first');
    }
    if (Object.keys(cart).length === 0) {
      errors.push('No items added to quote — please add at least one item');
    }
    if (!customer.name) errors.push('Name is required');
    if (!customer.email) errors.push('Email is required');
    if (!customer.phone) errors.push('Phone is required');
    if (!customer.state) errors.push('State is required');
    if (errors.length > 0) {
      setValidationErrors(errors);
      return;
    }
    setValidationErrors([]);
    setLoading(true);
    try {
      await saveQuote();
      setShowPricing(true);
      alert('Quote submitted successfully! You can now view your pricing below.');
    } catch (errorObj) {
      setErrorPopup({
        isOpen: true,
        errorMessage: errorObj.error?.message || 'An unknown error occurred',
        debugInfo: errorObj.zohoParams
      });
    } finally {
      setLoading(false);
    }
  };
  const startNewQuote = () => {
    setCart({});
    setShowPricing(false);
    setCustomer({
      name: '',
      email: initialEmail,
      phone: '',
      state: '',
      address: '',
      city: '',
      zip: ''
    });
  };
  return <div className="bg-white rounded-lg shadow-xl p-6 mb-8 relative" data-id="element-160" data-mp="33kk9e6rr1b3d">
      <ErrorPopup isOpen={errorPopup.isOpen} onClose={() => setErrorPopup({
      isOpen: false,
      errorMessage: '',
      debugInfo: null
    })} errorMessage={errorPopup.errorMessage} debugInfo={errorPopup.debugInfo} data-id="element-161" data-mp="1izm40eeslvmu" />
      <WholesaleInfoPopup isOpen={showWholesaleInfo} onClose={() => setShowWholesaleInfo(false)} data-id="element-162" data-mp="1wz5cj8bin8zo" />
      {loading && <div className="absolute inset-0 bg-white bg-opacity-90 rounded-lg flex items-center justify-center z-50" data-id="element-163" data-mp="14azpgewzp7wo">
          <div className="flex flex-col items-center" data-id="element-164" data-mp="19a2kr7n63zrg">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" data-id="element-165" data-mp="198j4vi5fbqq7"></div>
            <p className="mt-4 text-gray-700 font-medium" data-id="element-166" data-mp="1e35epgvuxb86">
              Submitting your quote...
            </p>
          </div>
        </div>}
      {!showPricing ? <>
          <div ref={quoteOptionsRef} className="mb-6" data-id="element-167" data-mp="lix3qp5hr1fk">
            <div className="flex flex-col md:flex-row justify-between mb-6" data-id="element-168" data-mp="djacsu5ywo2r">
              <div className="mb-4 md:mb-0" data-id="element-169" data-mp="9iqg1rpb3mh5">
                <h2 className="text-2xl font-bold text-blue-900 mb-2" data-id="element-170" data-mp="9hyxpikpzl8t">
                  Quote Options
                </h2>
                <div className="flex space-x-4" data-id="element-171" data-mp="nbzl5g681ltv">
                  <button className={`px-4 py-2 rounded-md ${quoteType === 'system' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`} onClick={() => setQuoteType('system')} disabled={loading} data-id="element-172" data-mp="iaio5vquyjik">
                    Quote System
                  </button>
                  <button className={`px-4 py-2 rounded-md ${quoteType === 'alacarte' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`} onClick={() => setQuoteType('alacarte')} disabled={loading} data-id="element-173" data-mp="4kyq33882afl">
                    Ala Carte
                  </button>
                </div>
              </div>
              <div className="flex items-start" data-id="element-174" data-mp="2swt8qdsq4t3f">
                <button onClick={() => setShowWholesaleInfo(true)} className="bg-amber-500 text-white px-4 py-2 rounded-md font-semibold hover:bg-amber-600 shadow-md transition-colors" data-id="element-175" data-mp="2sz75cr31ydd3">
                  Do you have a Wholesale Account?
                </button>
              </div>
            </div>
          </div>
          {quoteType === 'system' ? <SystemQuote priceType={priceType} onAddToCart={handleAddToCart} pricingData={pricingData} onPendingItemsChange={setHasPendingItems} showPricing={showPricing} data-id="element-176" data-mp="3cnfwqywrufbj" /> : <AlaCarteQuote priceType={priceType} onAddToCart={handleAddToCart} pricingData={pricingData} onPendingItemsChange={setHasPendingItems} showPricing={showPricing} data-id="element-177" data-mp="37ssh7pjqwv93" />}
          {Object.keys(cart).length > 0 && <div className="mb-8 border-t border-b py-6" data-id="element-178" data-mp="20ahoow2xad8b">
              <div className="flex justify-between items-center mb-4" data-id="element-179" data-mp="1vgn841im6edg">
                <h2 className="text-2xl font-bold text-blue-900" data-id="element-180" data-mp="1qibxvpoeq1up">
                  Items Added to Quote
                </h2>
                <button className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700" onClick={clearCart} data-id="element-181" data-mp="1lkjwm51vh3du">
                  START OVER
                </button>
              </div>
              <div className="overflow-x-auto" data-id="element-182" data-mp="2e6388nqe04tc">
                <table className="min-w-full bg-white border" data-id="element-183" data-mp="298bj21h4mwsu">
                  <thead data-id="element-184" data-mp="257hwbbff7o1j">
                    <tr className="bg-gray-100" data-id="element-185" data-mp="2581624ux364h">
                      <th className="py-2 px-4 border text-left" data-id="element-186" data-mp="259kjlnp6v32k">Item</th>
                      <th className="py-2 px-4 border text-center" data-id="element-187" data-mp="xupizl9qbasj">Quantity</th>
                    </tr>
                  </thead>
                  <tbody data-id="element-188" data-mp="tufhaksyz6jh">
                    {Object.entries(cart).map(([itemId, quantity]) => {
                const item = pricingData.find(p => p.id === itemId);
                if (!item) return null;
                return <tr key={itemId} data-id="element-189" data-mp="3efbeuzn8r6y5">
                          <td className="py-2 px-4 border" data-id="element-190" data-mp="3ee9s3xwv4w0l">
                            <div className="font-medium" data-id="element-191" data-mp="3j84ghenexz60">{item.name}</div>
                            {item.description && <div className="text-sm text-gray-600" data-id="element-192" data-mp="3o5wb4gffzzdw">
                                {item.description}
                              </div>}
                          </td>
                          <td className="py-2 px-4 border text-center" data-id="element-193" data-mp="zn7gh94x5w1">
                            {quantity}
                          </td>
                        </tr>;
              })}
                  </tbody>
                </table>
              </div>
              <div className="mt-4 bg-blue-50 p-4 rounded-lg" data-id="element-194" data-mp="27s62qxhaioyg">
                <p className="text-sm text-gray-700" data-id="element-195" data-mp="3oul7bxxxnko0">
                  Submit your contact information below to receive pricing
                  details for these items.
                </p>
              </div>
            </div>}
          <CustomerInfo customer={customer} setCustomer={setCustomer} data-id="element-196" data-mp="2lad4exljqou" />
          {validationErrors.length > 0 && <div className="mt-4 bg-red-50 border border-red-200 rounded-lg p-4" data-id="element-197" data-mp="7jbvsyr41nzs">
              <p className="font-semibold text-red-800 mb-2" data-id="element-198" data-mp="bl75orn3x9p6">
                Please fix the following before submitting:
              </p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-199" data-mp="lcjlulzjmbfd">
                {validationErrors.map((error, i) => <li key={i} className="text-red-700 text-sm" data-id="element-200" data-mp="qcfqmng2e6vz" data-mpi={i}>
                    {error}
                  </li>)}
              </ul>
            </div>}
          <div className="mt-6 text-center" data-id="element-201" data-mp="zckvoqxsct6z">
            <button className="bg-blue-600 text-white px-6 py-3 rounded-md font-bold text-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors" onClick={handleSubmit} disabled={loading} data-id="element-202" data-mp="zddu94mlcce1">
              {loading ? 'Submitting...' : 'Submit Quote Request'}
            </button>
          </div>
        </> : <>
          <div className="mb-6" data-id="element-203" data-mp="25x88nbtsam08">
            <h2 className="text-2xl font-bold text-blue-900 mb-2" data-id="element-204" data-mp="33imd43lmwn3f">
              Your Quote Pricing
            </h2>
            <p className="text-gray-700" data-id="element-205" data-mp="2yjj6ieq0a8tc">
              Thank you for submitting your quote request! Here are your pricing
              details:
            </p>
          </div>
          <Summary cart={cart} pricingData={pricingData} priceType={priceType} total={calculateTotal()} onClearCart={startNewQuote} data-id="element-206" data-mp="2ou9f712zku6a" />
          <div className="mt-6 bg-blue-50 p-4 rounded-lg" data-id="element-207" data-mp="3hix5jb2le9qp">
            <h3 className="font-semibold text-blue-900 mb-2" data-id="element-208" data-mp="3hhcbrno3qutw">
              What happens next?
            </h3>
            <p className="text-gray-700" data-id="element-209" data-mp="1fnh8vknx43sz">
              We have received your quote request and will contact you shortly
              at {customer.email} to discuss your order and answer any questions
              you may have.
            </p>
          </div>
          <div className="mt-6 text-center" data-id="element-210" data-mp="1at3kw3bl4yyc">
            <button className="bg-blue-600 text-white px-6 py-3 rounded-md font-bold text-lg hover:bg-blue-700 transition-colors" onClick={startNewQuote} data-id="element-211" data-mp="1as20v9cld24h">
              Create New Quote
            </button>
          </div>
        </>}
    </div>;
}